// Exporting it in module.js way since it is being used in node process
module.exports = {
  networkTimeoutThreshold: 'process.env.NETWORK_TIMEOUT' || 40000,
  url: 'process.env.url' || 'https://eswebportalqanew.earlysalary.com/',
  cmsUrl: 'process.env.CMS_ENDPOINT' || 'https://altcont.fibe.in',
  portalHostName:
    'process.env.PORTAL_HOST_NAME' || 'https://portal.earlysalary.com',
  hostName: 'process.env.HOST_NAME' || 'https://www.earlysalary.com',
  bucket: 'process.env.bucket' || 'esdoc',
};
 